
export const PaymentProviderNames = Object.freeze({
	MOBILE_PAY: "upodiWithMobilePay",
	NETS: "upodiWithNets",
	BILLWERK: "billwerk"
});

export const PaymentProviders = [
	{
		name: PaymentProviderNames.NETS,
		description: "shopComponents.gt2.subscriptionPaymentMethod.paymentCard",
		logo: "all-cards-logo.svg",
		browser: "_blank",
		redirectTo: "/subscription-plans"
	},
	{
		name: PaymentProviderNames.MOBILE_PAY,
		description: "",
		logo: "mobile-pay-logo.svg",
		browser: "_system",
		redirectTo: "/subscription-payment-done"
	},
	{
		name: PaymentProviderNames.BILLWERK,
		description: "",
		logo: "all-cards-logo.svg",
		browser: "_blank",
		redirectTo: "/subscription-payment-done"
	}
];
